const DownloadLink = (link: string, label: string) => `
  <a clicktracking="off" href="${link}" style="margin-right: 15px;color:#505066;text-decoration: none;text-wrap: nowrap;">
    <div style="margin-right: 5px;display: inline-block;vertical-align: middle;">
      <img style="width: 22px;" src="https://stockhide.s3.amazonaws.com/reports-assets/download-icon.png" alt="download_icon" />
    </div>
    ${label}
  </a>
`;


export const NotificationContainer = (
  shop: string, notificationIcon:
    string,
  title: string,
  date: string,
  subtitle?: string,
  pdfLink = "",
  csvLink = "",
  excelLink = "",
) => (`
  <div class="notification-container--wrapper">
    <div class="notification-container--first-line">
      <span class="notification-container--first-line-date">${date}</span>
      <span class="notification-container--first-line-shop">${shop}</span>
    </div>
    <div style="font-size: 26px;font-weight: 600;margin-bottom: 15px;">
    <div style="display: inline-block;vertical-align: middle;color: #000001;line-height:28px;">
      ${title}
      <div style="margin-left: 5px;display: inline-block;vertical-align: middle;">
        <img src="${notificationIcon}" alt="notification-icon" />
      </div>
    </div>
    </div>
    <div style="font-size: 16px;font-style: normal;font-weight: 500;margin-bottom: 15px;color: #000001;">
      ${subtitle ?? ""}
    </div>
    <div class="notification-container--desktop-links">
      ${pdfLink ? DownloadLink(pdfLink, "Summary PDF") : ""}
      ${csvLink ? DownloadLink(csvLink, "Summary CSV") : ""}
      ${excelLink ? DownloadLink(excelLink, "Summary EXCEL") : ""}
    </div>
    <div class="notification-container--mobile-links">
      ${pdfLink ? DownloadLink(pdfLink, "PDF") : ""}
      ${csvLink ? DownloadLink(csvLink, "CSV") : ""}
      ${excelLink ? DownloadLink(excelLink, "EXCEL") : ""}
  </div>
  </div>
`);